<template lang="html">
    <div class="page splash">
        <div class="columns">
            <div class="column is-half">
                <img
                    class="app-logo"
                    src="@/assets/bc-water-tool-logo.svg"
                    :alt="`${appTitle} logo`"
                >
                <h1
                    class="title is-size-1 has-text-weight-bold"
                    v-text="appTitle"
                />
                <p>
                    The {{ appTitle }} ({{ appTitleShort }}) is a point-and-click tool that helps scientists,
                    industry explorers, communities and government decision-makers to understand accurate,
                    real-time information about water resources in British Columbia.
                </p>
                <hr>
                <h2>How to Use:</h2>
                <router-menu
                    :routes="routes"
                />
                <hr>
                <div class="disclaimer">
                    <h4 class="has-text-weight-bold">
                        Disclaimer
                    </h4>
                    <p>
                        It is the responsibility of all persons who use this site to independently confirm the
                        accuracy of the data, information, or results obtained through the use of
                        {{ appTitleShort }}, should it be necessary for their purpose. No warranty of quality,
                        accuracy, or completeness of any information, data or product from these web pages is made.
                        No liability or blame for loss or damages incurred by any person or business entity based
                        on the use of {{ appTitleShort }} is accepted. It is provided 'AS IS' without warranty or
                        condition of any nature. {{ appTitleShort }} carries no guarantee of any kind, expressed or
                        implied. Use of this site will constitute your acceptance of these terms and conditions.
                    </p>
                </div>
                <hr>
                <p>
                    <img
                        class="foundry-logo"
                        src="@/assets/foundry-spatial-logo-with-text.svg"
                    >
                    Powered by <a
                        target="_blank"
                        href="https://www.foundryspatial.com"
                    >Foundry Spatial</a>
                </p>
                <br>
                <p>
                    Comments/Questions/Concerns?
                </p>
                <p>
                    Submit them to
                    <a
                        href="https://foundryspatialsm.atlassian.net/servicedesk/customer/portal/11"
                        target="_blank"
                    >
                        https://foundryspatialsm.atlassian.net/servicedesk/customer/portal/11
                    </a>
                </p>
                <hr>
                <div class="columns splash-footer">
                    <img
                        class="column is-narrow"
                        src="@/assets/BC_FOR_H_RGB_pos.png"
                        alt="British Columbia Ministry of Forests Logo"
                    >
                    <p
                        class="column"
                    >
                        The {{ appTitle }} is provided for public use by the BC Ministry of Forests.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RouterMenu from '@foundryspatial/router-menu';

import watershed from '@/components/images/menuIcons/watershed.vue';

export default {
    components: {
        RouterMenu,
    },
    data: () => ({
        routes: [
            {
                icon: watershed,
                link: 'watershed',
                title: 'Watershed Reporting',
                description: 'Click on a stream, lake, or river to see the watershed associated with that water feature and generate a detailed report about it. Map markers show the location of existing water rights, which can be clicked on for further details.',
            },
        ],
    }),
    computed: {
        appTitle() {
            return process.env.VUE_APP_TITLE;
        },
        appTitleShort() {
            return process.env.VUE_APP_TITLE_SHORT;
        },
    },
};
</script>

<style lang="scss">
    .splash-footer {
        padding-top: 1rem;
        font-size: 1rem;

        img {
            // somehow this prevents the image from being
            // stretched vertically!
            align-self: baseline;
        }
    }

    .splash.page {
        height: 100vh;
        background: $white;
        padding-left: 5em;
        padding-right: 1em;
        padding-top: 2em;
        overflow-y: auto;
        overflow-x: hidden;

        .foundry-logo {
            width: 4.8rem;
        }

        h1 {
            font-weight: 900;
            font-size: 2.25rem;
            line-height: 2.25rem;
            margin-bottom: 0.8rem;
        }

        h2 {
            font-size: 1.5rem;
            font-weight: 900;
            margin-bottom: 0.4rem;
        }

        hr {
            background-color: $light-grey-accent;
            margin: 0.94rem 0;
        }

        img.app-logo {
            max-width: 12rem;
            padding-bottom: 0.8rem;
        }

        .disclaimer {
            padding: 0.5rem 0;
            font-size: 0.625rem;
        }
    }

</style>
